<div mat-dialog-title>
	<span class="dialog-title" translate>
		delete.draft
	</span>

	<button type="button" mat-icon-button class="close-button"
	(click)="evtCancel()">
		<mat-icon color="accent" svgIcon="md:close"></mat-icon>
	</button>
</div>

<div mat-dialog-content>
	<p>
		<span translate>want.to.delete.draft</span>
		<b *ngIf="draftName" class="delete-popup-alignment">{{draftName}}</b>
		<span class="delete-popup-alignment">?</span>
	</p>

	<p>
		<span translate>confirmation.message</span>
	</p>
</div>

<div mat-dialog-actions>
	<button type="submit" mat-raised-button
		class="dialog-button" (click)="evtConfirm()" copoFocusMe>
		<span translate>dialog.apply</span>
	</button>
</div>
